
export const paType = {
  I: 'Individual',
  F: 'Family'
}

export const relationship = {
  S: 'Spouse',
  C: 'Child'
}

export const paymentMode = {
  CC: 'Credit Card/Debit Card',
  CH: 'Cash/Cheque'
}

export const maritalStatus = {
  S: 'Single',
  M: 'Married',
  D: 'Divorced',
  W: 'Widowed'
}
